import { render, staticRenderFns } from "./ActionsSlider.vue?vue&type=template&id=3df33e46&scoped=true"
import script from "./ActionsSlider.vue?vue&type=script&lang=js"
export * from "./ActionsSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df33e46",
  null
  
)

export default component.exports